import React, { useState } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill'; 
import 'react-quill/dist/quill.snow.css';
import { Container, Typography, TextField, Button, Box, Snackbar, Alert, Grid, Paper } from '@mui/material';
import MediaUploadField from './MediaUploadField';
 
const modules = {
    toolbar: [
        [{ 'font': [] }],
        [{ 'header': '1' }, { 'header': '2' }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link', 'image', 'blockquote', 'code-block'],
        ['clean'],
    ],
};

const stripHtml = (value = '') =>
  String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const DashboardVerbetes = () => {
    const apiUrl = process.env.REACT_APP_API_URL || '/api';

    const [formData, setFormData] = useState({
        titulo: '',
        autor: '',
        imgcard: '',
        instituicaoautor: '',
        linkpdfverbete: '',
        linkpdfdoclink: '',
        edicoes: '',
        trechoTraduzidoModernizado: '',
        palavrachave: '',
        autorDocumento: '',
        nomeDocumento: '',
        dataComposicao: '',
        lugarComposicaoOuImpressao: '',
        imagemDocumento: '',
        textoPortugues: '',
        textoEspanhol: '',
        nomeImagemDocumento: '',
        id: null,  // Para edição
    });

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ type: '', text: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const setFieldValue = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleConteudoChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
    };
    

    
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const token = localStorage.getItem('token');
        
        if (!token) {
            setAlertMessage({ type: 'error', text: 'Você precisa estar autenticado para adicionar ou editar verbetes.' });
            setOpenSnackbar(true);
            return;
        }

        const requiredFields = [
            ['Título', formData.titulo],
            ['Autor', formData.autor],
            ['Instituição do autor', formData.instituicaoautor],
            ['Imagem do card', formData.imgcard],
            ['PDF do verbete', formData.linkpdfverbete],
            ['Palavras-chave', formData.palavrachave],
            ['PDF do documento', formData.linkpdfdoclink],
            ['Trecho traduzido e modernizado', formData.trechoTraduzidoModernizado],
            ['Texto em português', formData.textoPortugues],
            ['Texto em outro idioma', formData.textoEspanhol],
        ];
        const missing = requiredFields
            .filter(([, value]) => !stripHtml(value))
            .map(([label]) => label);

        if (missing.length) {
            setAlertMessage({
                type: 'error',
                text: `Preencha os campos obrigatórios: ${missing.join(', ')}.`,
            });
            setOpenSnackbar(true);
            return;
        }

        const payload = {
            ...formData,
            palavrachave: Array.isArray(formData.palavrachave)
                ? formData.palavrachave
                : String(formData.palavrachave)
                      .split(',')
                      .map((item) => item.trim())
                      .filter(Boolean),
        };
    
        try {
            await (formData.id
                ? axios.put(`${apiUrl}/verbetes/${formData.id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                : axios.post(`${apiUrl}/verbetes`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                }));
    
            setAlertMessage({
                type: 'success',
                text: formData.id ? 'Verbete atualizado com sucesso!' : 'Verbete criado com sucesso!',
            });
            setOpenSnackbar(true);

            // Limpar os dados do formulário após envio
            setFormData({
                titulo: '',
                autor: '',
                imgcard: '',
                instituicaoautor: '',
                linkpdfverbete: '',
                linkpdfdoclink: '',
                edicoes: '',
                trechoTraduzidoModernizado: '',
                palavrachave: '',
                autorDocumento: '',
                nomeDocumento: '',
                dataComposicao: '',
                lugarComposicaoOuImpressao: '',
                imagemDocumento: '',
                textoPortugues: '',
                textoEspanhol: '',
                nomeImagemDocumento: '',
                id: null
            });
        } catch (error) {
            const backendMessage = error?.response?.data?.error || error?.response?.data?.message;
            setAlertMessage({ type: 'error', text: backendMessage || 'Erro ao salvar os dados do verbete. Tente novamente.' });
            setOpenSnackbar(true);
        }
    };
    

    

    const handleCloseSnackbar = () => setOpenSnackbar(false);
    const handleUploadError = (message) => {
        setAlertMessage({ type: 'error', text: message });
        setOpenSnackbar(true);
    };
    const handleUploadSuccess = (message) => {
        setAlertMessage({ type: 'success', text: message });
        setOpenSnackbar(true);
    };


    return (
        <Container maxWidth="lg">

<hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
<hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

<Typography
                variant="h2"
                align="center"
                gutterBottom
                style={{
                    fontFamily: "'Lato', serif",
                    color: "black",
                    borderBottom: "4px solidrgb(8, 8, 7)",
                    paddingBottom: "10px",
                    textTransform: "uppercase",
                    borderBottom: "4px solid #d4af37",
                    animation: "glow 2s infinite alternate",
                    marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
            > 
                Painel de Administração de Verbetes
            </Typography>
            
            
                <form onSubmit={handleSubmit}>
                    <Typography variant="h5" align="center" gutterBottom>
                        {formData.id ? 'Editar Verbetes' : 'Adicionar Novo Verbetes'}
                    </Typography>
                    
                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Título"
                            variant="outlined"
                            name="titulo"
                            value={formData.titulo}
                            onChange={handleChange}
                            required
                        />
                    </Box>
                    
                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Autor"
                            variant="outlined"
                            name="autor"
                            value={formData.autor}
                            onChange={handleChange}
                            required
                        />
                    </Box>

                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Instituição do Autor"
                            variant="outlined"
                            name="instituicaoautor"
                            value={formData.instituicaoautor}
                            onChange={handleChange}
                            required
                        />
                    </Box>

                    <Box mb={3}>
                        <MediaUploadField
                            label="Imagem do Card"
                            name="imgcard"
                            value={formData.imgcard}
                            onChange={setFieldValue}
                            folder="imagenscards"
                            accept="image/*"
                            required
                            onError={handleUploadError}
                            onSuccess={handleUploadSuccess}
                        />
                    </Box>

                    <Box mb={3}>
                        <MediaUploadField
                            label="PDF do Verbete"
                            name="linkpdfverbete"
                            value={formData.linkpdfverbete}
                            onChange={setFieldValue}
                            folder="verbetes"
                            accept=".pdf,application/pdf"
                            required
                            onError={handleUploadError}
                            onSuccess={handleUploadSuccess}
                        />
                    </Box>

                    

                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="palavrachave"
                            variant="outlined"
                            name="palavrachave"
                            value={formData.palavrachave}
                            onChange={handleChange}
                            required
                        />
                    </Box>
                     
                     


                    <Box mb={3}>
                        <MediaUploadField
                            label="PDF do Documento"
                            name="linkpdfdoclink"
                            value={formData.linkpdfdoclink}
                            onChange={setFieldValue}
                            folder="pdfDoc"
                            accept=".pdf,application/pdf"
                            required
                            onError={handleUploadError}
                            onSuccess={handleUploadSuccess}
                        />
                    </Box>

                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Autor do Documento"
                            variant="outlined"
                            name="autorDocumento"
                            value={formData.autorDocumento}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Nome do Documento"
                            variant="outlined"
                            name="nomeDocumento"
                            value={formData.nomeDocumento}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Data de Composição"
                            variant="outlined"
                            name="dataComposicao"
                            value={formData.dataComposicao}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Lugar de Composição ou Impressão"
                            variant="outlined"
                            name="lugarComposicaoOuImpressao"
                            value={formData.lugarComposicaoOuImpressao}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box mb={3}>
                        <MediaUploadField
                            label="Imagem do Documento"
                            name="imagemDocumento"
                            value={formData.imagemDocumento}
                            onChange={setFieldValue}
                            folder="imagensverbete"
                            accept="image/*"
                            onError={handleUploadError}
                            onSuccess={handleUploadSuccess}
                        />
                    </Box>

                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Nome Local da imagem Documento, exemplo:  Imagem do prólogo, edição de Sevilha, 1498. Manuscrito da Biblioteca Nacional de Espanha."
                            variant="outlined"
                            name="nomeImagemDocumento"
                            value={formData.nomeImagemDocumento}
                            onChange={handleChange}
                        />
                    </Box>

                     
                    <Box mb={3}>
                     
    <Typography variant="body1" gutterBottom>
    Edicoes:
    </Typography>
                        <ReactQuill
                            value={formData.edicoes}
                            onChange={(value) => handleConteudoChange('edicoes', value)}
                            theme="snow"
                            modules={modules}

                            style={{ height: '100px' }}
                        />
                    </Box>
                    <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

                    <Box mb={5}>
    <Typography variant="body1" gutterBottom>
        Trecho Traduzido e Modernizado:
    </Typography>
    <ReactQuill
        value={formData.trechoTraduzidoModernizado}
        onChange={(value) => handleConteudoChange('trechoTraduzidoModernizado', value)}
        theme="snow"
        modules={modules}
        style={{ height: '300px' }}
    />
</Box>
<hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

<Box mb={5}>
    <Typography variant="body1" gutterBottom>
        Conteúdo Texto em Portugues:
    </Typography>
    <ReactQuill
        value={formData.textoPortugues}
        onChange={(value) => handleConteudoChange('textoPortugues', value)}
        theme="snow"
        modules={modules}
        formats={[
            'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline', 'strike',
            'color', 'background', 'align', 'link', 'image', 'blockquote', 'code-block'
        ]}
        style={{ height: '300px' }}
    />
</Box>
<hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

<Box mb={5}>
    <Typography variant="body1" gutterBottom>
        Conteúdo Texto em Outro idioma:
    </Typography>
    <ReactQuill
        value={formData.textoEspanhol}
        onChange={(value) => handleConteudoChange('textoEspanhol', value)}
        theme="snow"
        modules={modules}
        style={{ height: '300px' }}
    />
</Box>


                     

 

                    <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
    <Alert onClose={handleCloseSnackbar} severity={alertMessage.type} sx={{ width: '100%' }}>
        {alertMessage.text}
    </Alert>
</Snackbar>
<Box mb={3}>
    <Button
        fullWidth
        variant="contained"
        color="primary"
        type="submit"
    >
        {formData.id ? 'Atualizar Verbete' : 'Criar Verbete'}
    </Button>
</Box>

                </form>
            

 
                 
             
        </Container>
    );
};

export default DashboardVerbetes;
